<template>
  <section class="userLocation">
    <h2 class="userLocation__title">Empresa *</h2>
    <div class="userLocation__contentRow">
      <CustomCheckboxVue v-for="company in companies" :key="company.id" :id="company.id" :label="company.name" :isChecked="company.isSelected" @toggleSelection="setNewCompanies" />
    </div>

    <h2 class="userLocation__title">Area *</h2>
    <select class="userLocation__input" ref="areaSelect" v-model="$store.state.user.dataUser.area" @change="validateSelect('area', 'areaSelect', 'el area')">
      <option value="">Seleccione un area</option>
      <option v-for="area in optionsAreas" :key="area.value" :value="area.value">
        {{ area.name }}
      </option>
    </select>
    <span ref="area" class="userLocation__error"></span>
    <div v-if="showPlatformTypeSelector">
      <h2 class="userLocation__title">Tipo de Categoria *</h2>
      <PlatformTypeSelector :subjectType="platformSubject" v-model="$store.state.user.dataUser.platformType" />
    </div>

    <h2 class="userLocation__title">Sede</h2>
    <div class="userLocation__contentInput">
      <label for="city">Ciudad *</label>
      <select
        class="userLocation__input"
        id="city"
        ref="citySelect"
        v-model="$store.state.user.dataUser.city"
        @change="changeValues(['office', 'room']), validateSelect('city', 'citySelect', 'la ciudad')">
        <option value="">Seleccione una ciudad</option>
        <option v-for="city in cities" :key="city.value" :value="city.value">
          {{ city.text }}
        </option>
      </select>
    </div>
    <span ref="city" class="userLocation__error"></span>

    <div class="userLocation__contentInput" v-if="$store.state.user.dataUser.hasOwnProperty('office')">
      <label for="office">Oficina</label>
      <select
        class="userLocation__input"
        id="office"
        ref="officeSelect"
        v-model="$store.state.user.dataUser.office"
        @change="changeValues(['room']), validateSelect('office', 'officeSelect', 'la oficina')">
        <option value="">Seleccione una oficina</option>
        <option v-for="office in offices" :key="office.value" :value="office.value">
          {{ office.text }}
        </option>
      </select>
    </div>
    <span ref="office" class="userLocation__error"></span>

    <div class="userLocation__containerCol">
      <div class="userLocation__contentInput" v-if="$store.state.user.dataUser.hasOwnProperty('workShiftName')">
        <label for="workShift">Turno *</label>
        <select
          class="userLocation__input"
          id="workShift"
          ref="workShiftSelect"
          v-model="$store.state.user.dataUser.workShiftName"
          @change="changeValues(['room']), validateSelect('room', 'workShiftSelect', 'el turno')">
          <option value="">Seleccione</option>
          <option v-for="workShift in workShifts" :key="workShift.value" :value="workShift.value">
            {{ workShift.text }}
          </option>
        </select>
      </div>

      <div class="userLocation__contentInput" v-if="$store.state.user.dataUser.hasOwnProperty('room')">
        <label for="room">Habitación *</label>
        <select
          class="userLocation__input"
          id="room"
          ref="roomSelect"
          v-model="$store.state.user.dataUser.room"
          :disabled="getRoomOptions.length === 0"
          @change="validateSelect('room', 'roomSelect', 'la habitación')">
          <option value="">{{ !getRoomOptions.length ? "-" : "Selecciona" }}</option>
          <option v-for="room in getRoomOptions" :key="room.value" :value="room.value">
            {{ room.text }}
          </option>
        </select>
      </div>
    </div>
    <span ref="room" class="userLocation__error"></span>
    <div class="userLocation__errorMessage" v-if="getRoomOptions.length === 0 && $store.state.user.dataUser.role === 'model' && $store.state.user.dataUser.office">
      No hay habitaciones disponibles actualmente. Intenta liberar una habitación o asignar después.
    </div>
  </section>
</template>

<script>
  import { mapGetters } from "vuex";
  import { formatSelection } from "@/js/validation.js";
  import CustomCheckboxVue from "@/components/input/CustomCheckbox.vue";
  import PlatformTypeSelector from "@/components/molecules/PlatformTypeSelector.vue";

  export default {
    components: { CustomCheckboxVue, PlatformTypeSelector },
    data() {
      return {
        workShifts: [
          { value: "morning", text: "Mañana" },
          { value: "late", text: "Tarde" },
          { value: "night", text: "Noche" },
        ],
      };
    },
    computed: {
      ...mapGetters("users", ["getModels"]),
      ...mapGetters("rooms", { getRooms: "getData" }),
      ...mapGetters(["listCompanies"]),

      companies() {
        return this.listCompanies.map(({ _id, name }) => ({
          id: _id,
          name,
          isSelected: this.user.companies.includes(_id),
        }));
      },

      user() {
        return this.$store.state.user.dataUser;
      },

      isEditUser() {
        return !!this.user?._id;
      },

      isGroupAccount() {
        const { accountType, role, platformType } = this.user || {};
        if (accountType === "group") return true;
        if (role !== "model") return false;

        const list = Array.isArray(platformType) ? platformType : platformType ? [platformType] : [];
        return list.includes("group");
      },

      cities() {
        return this.$cities.map((city) => ({ value: city, text: city }));
      },

      offices() {
        return this.$store.getters["offices/getData"].filter(({ cityName }) => cityName === this.user.city).map(({ officeName }) => ({ value: officeName, text: officeName }));
      },

      getRoomOptions() {
        const { role, platformType: userPlatformTypes, office, workShiftName, room: userRoom } = this.user;

        if (role === "model" && this.isSatelite) {
          return [{ value: "Satelite", text: "Satelite" }];
        }

        const rooms = this.getRooms || [];

        const userPlatforms = Array.isArray(userPlatformTypes) ? userPlatformTypes : [userPlatformTypes];

        const filteredRooms = rooms
          .filter((room) => {
            const officeMatch = room.officeName === office;
            const isSameRoom = room.roomName === userRoom;

            if (isSameRoom) return true;
            if (!officeMatch) return false;

            const modelInRoom = this.getModels.find((model) => model.room === room.roomName && model.workShift?.name === workShiftName);

            if (modelInRoom) return false;

            const roomPlatforms = Array.isArray(room.platformType) ? room.platformType : [room.platformType];

            const platformMatch = roomPlatforms.some((p) => userPlatforms.includes(p));

            return platformMatch;
          })
          .map(({ roomName }) => ({ value: roomName, text: roomName }));

        return filteredRooms;
      },

      optionsAreas() {
        const areas = this.$store.state.user.companyAreas || [];
        return areas.map(({ _id, name }) => ({ name, value: _id }));
      },

      isSatelite() {
        return this.$store.state.user.dataUser?.office === "Satelite";
      },

      platformSubject() {
        const { role, area } = this.user || {};
        if (["model", "monitor", "coordinator"].includes(role)) {
          return role;
        }

        if (!area) return null;

        const areas = this.$store.state.user.companyAreas || [];
        const areaName = areas.find((a) => a._id === area)?.name || "";
        if (!areaName) return null;

        const normalized = areaName.toLowerCase();
        if (/modelo|model/.test(normalized)) return "model";
        if (/monitor/.test(normalized)) return "monitor";
        if (/coordinator|coordinador/.test(normalized)) return "coordinator";
        return null;
      },

      showPlatformTypeSelector() {
        const allowedRoles = new Set(["model", "monitor", "coordinator"]);
        const allowedGroupRoles = new Set(["monitor", "coordinator"]);
        const { role, accountType } = this.user || {};
        const isGroupFlow = accountType === "group" || this.isGroupAccount;

        if (!this.platformSubject) return false;

        if (isGroupFlow) {
          return allowedGroupRoles.has(role);
        }

        return allowedRoles.has(role);
      },
    },

    watch: {
      platformSubject(newVal, oldVal) {
        if (this.isEditUser) return;
        if (newVal !== oldVal) {
          this.$store.state.user.dataUser.platformType = this.isGroupAccount ? ["group"] : null;
        }
      },
    },

    methods: {
      setNewCompanies(id) {
        const arr = this.$store.state.user.dataUser.companies;
        const idx = arr.findIndex((company) => company === id);
        if (idx !== -1) arr.splice(idx, 1);
        else arr.push(id);
      },

      changeValues(valuesToChange) {
        valuesToChange.forEach((key) => this.$store.state.user.dataUser.hasOwnProperty(key) && (this.$store.state.user.dataUser[key] = ""));
      },

      validateSelect(ref, refLocal, text, data) {
        const reference = this.$refs[ref];
        const referenceLocal = this.$refs[refLocal];
        const dataToSet = data ?? event?.srcElement ?? { value: "" };

        const response = formatSelection(reference, text, dataToSet);
        this.updateStyles(reference, referenceLocal, response);
        return response;
      },

      updateStyles(reference, referenceLocal, response) {
        reference.style.display = response ? "none" : "block";
        referenceLocal.style["border-color"] = response ? "#d8d8d8" : "#bd0909";
      },

      verifyNext() {
        const { city, office, workShiftName, room, area, platformType } = this.user;

        const citySelect = this.validateSelect("city", "citySelect", "la ciudad", { value: city });

        const officeSelect = !this.user.hasOwnProperty("office") || this.validateSelect("office", "officeSelect", "la oficina", { value: office });

        const workShiftSelect = !this.user.hasOwnProperty("workShiftName") || this.validateSelect("room", "workShiftSelect", "el turno", { value: workShiftName });

        const roomSelect = !this.user.hasOwnProperty("room") || this.validateSelect("room", "roomSelect", "la habitación", { value: room });

        const areaSelect = this.validateSelect("area", "areaSelect", "el area", { value: area });

        const platformOk = !this.platformSubject || this.isGroupAccount || !!platformType;

        return citySelect && officeSelect && workShiftSelect && roomSelect && areaSelect && platformOk;
      },
    },

    async mounted() {
      if (this.isEditUser) {
        this.verifyNext();
      }
    },
  };
</script>

<style lang="scss">
  .userLocation {
    .customCheckbox {
      font-weight: bold;
      &--RoaAgency {
        color: $pinkRoa;
      }
    }

    @include Flex(column, flex-start, flex-start);
    width: 100%;
    gap: $mpadding;

    &__title {
      font-weight: lighter;
      font-size: 24px;
    }

    &__contentInput {
      width: 100%;
    }

    &__contentRow {
      @include Flex(row, flex-start);
      gap: $space-12;
      flex-wrap: wrap;
    }
    &__errorMessage {
      font-weight: 600;
      font-size: 11px;
      color: $primary-color;
    }
    &__input {
      width: 100%;
      height: 40px;
      border: 1px solid $alto;
      border-radius: 6px;
      padding: 5px;
      &:focus {
        outline: none;
      }
    }

    &__containerCol {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
      width: 100%;
      gap: 15px;
    }

    &__error {
      display: none;
      margin-top: -10px;
      font-weight: 600;
      font-size: 0.8em;
      color: $primary-color;
    }
  }
</style>
